<template>
  <v-form ref="form" @submit.prevent="onSubmit">
    <v-text-field
      ref="email"
      v-model="email"
      :rules="rules.email"
      :label="$t('login.components.loginForm.email')"
      color="secondary"
      autocapitalize="off"
      spellcheck="false"
      class="mt-6"
      validate-on-blur
      autofocus
    />
    <v-text-field
      ref="password"
      v-model="password"
      :type="showPassword ? 'text' : 'password'"
      :append-icon="showPassword ? 'fa-light fa-eye-slash' : 'fa-light fa-eye'"
      :rules="rules.password"
      :label="$t('login.components.loginForm.password')"
      color="secondary"
      autocomplete="off"
      spellcheck="false"
      class="mt-4 mb-12 pb-6"
      validate-on-blur
      @click:append="showPassword = !showPassword"
    />
    <primary-button :loading="loading" type="submit">
      {{ $t('login.components.loginForm.submit') }}
    </primary-button>
  </v-form>
</template>

<script>
import PrimaryButton from '@/modules/Layout/components/PrimaryButton.vue';
import validator from 'validator';

export default {
  components: { PrimaryButton },
  props: {
    value: {
      type: Object,
      required: true,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      showPassword: false,
      rules: {
        email: [
          (v) => !validator.isEmpty(v) || this.$t('login.validation.isEmpty'),
          (v) => validator.isEmail(v) || this.$t('login.validation.isNotEmail'),
        ],
        password: [(v) => !validator.isEmpty(v) || this.$t('login.validation.isEmpty')],
      },
    };
  },
  computed: {
    email: {
      get() {
        return this.value.email;
      },
      set(email) {
        this.$emit('input', {
          ...this.value,
          email,
        });
      },
    },
    password: {
      get() {
        return this.value.password;
      },
      set(password) {
        this.$emit('input', {
          ...this.value,
          password,
        });
      },
    },
  },
  methods: {
    onSubmit() {
      // Fix for password manager from firefox
      if ('' === this.email || '' === this.password) {
        this.$emit('input', {
          email: this.$refs.email.$el.getElementsByTagName('input')[0].value,
          password: this.$refs.password.$el.getElementsByTagName('input')[0].value,
        });
      }
      if (this.$refs.form.validate()) {
        this.$emit('submit');
      }
    },
  },
};
</script>
